import ConnectionsListPageContainer from './containers/ConnectionsListPageContainer'

export default ConnectionsListPageContainer
